import { GrocyBasics } from '../../../../core/entities/grocy/shared/basics.entity';
import { FormOptions } from '../../../../forms/form-options/base.form-options';

export class GrocyDashboardQuickActionTransferFormOptions extends FormOptions {
  grocyLocations: GrocyBasics[] = [];
}
